import { useDispatch, useSelector } from 'react-redux'
import { getTaxDisplayDialog } from '../../Selectors'
import { useCallback } from 'react'
import { setTaxDisplayDialog } from '../../ActionCreators'
import Dialog from '../../../components/dialog/Dialog'
import styles from './VNTaxDisplayDialog.module.scss'
import { Button } from '@material-ui/core'
import cn from 'classnames'
import useTaxResults from '../../../VNTaxes/hooks/useTaxResults'
import { centsToDollars } from '../../../utils/formatters'

export const VNTaxDisplayDialog = ({ classNames }) => {
  const dispatch = useDispatch()
  const { taxRulesBreakdown } = useTaxResults()

  const dialogClassNames = {
    dialog: cn(styles.VNTaxDisplayDialog, classNames?.VNTaxDisplayDialog),
    dialogContainer: classNames?.dialogContainer,
  }

  const dialogOptions = useSelector((state) => getTaxDisplayDialog(state))

  const closeHandler = useCallback(() => {
    dispatch(setTaxDisplayDialog({ open: false }))
  }, [dispatch])

  if (!dialogOptions.get('open')) {
    return null
  }

  return (
    <Dialog classNames={dialogClassNames} isKiosk={false} opaque={false}>
      <div className={cn(styles.container, classNames?.container)}>
        <div className={styles.rulesContainer}>
          {Object.values(taxRulesBreakdown).map((rule, index) => (
            <div key={index} className={styles.rule}>
              {rule.taxRuleName}: {centsToDollars(rule.taxRuleAmountInCents)}
            </div>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <Button className={styles.button} onClick={closeHandler}>
            OKAY
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
